import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { makeStyles } from "@material-ui/core";
import { bookingApi } from "functions/apis";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import { MailOutline } from "@material-ui/icons";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput";
import Button from "components/CustomButtons/Button.js";
import { validateImageUpload } from "functions/Helper";

const useStyles = makeStyles(styles);

export default function UploadOnlineBookingHomeContent(props) {
  const abortSignal = useRef(new AbortController());

  const { id } = useParams();

  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [redirect, setRedirect] = useState(false);
  const [bannerData, setBannerData] = useState({
    title: "",
    description: "",
    banner: "",
    url: "",
    bannerFileID: null
  });
  const [disabled, setDisabled] = React.useState(false);

  useEffect(() => {
    return () => abortSignal.current.abort();
  }, []);

  useEffect(() => {
    bookingApi
      .get("OnlineBookingHomeContents/" + id, {
        signal: abortSignal.current.signal
      })
      .then(data => {
        setBannerData(prev => ({
          ...prev,
          title: data.title,
          banner: data.banner,
          description: data.description,
          url: data.action,
          bannerFileID: data.bannerFileID
        }));
      })
      .catch(error => console.log(error));
  }, [id]);

  const handleUpload = e => {
    const file = e.target.files[0];
    const error = validateImageUpload(file);
    setUploadError(error);
    setUploadedFile(error ? null : { file });
  };

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    let data = new FormData();
    data.append("file", uploadedFile.file);

    bookingApi
      .post("OnlineBookingHomeContents/Banner/" + id, data, {
        signal: abortSignal.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();
  return redirect ? (
    <Redirect to={"/admin/OnlineBookingHomeContentList"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>UPLOAD BANNER IMAGE</h4>
          </CardHeader>

          <CardBody>
            {bannerData.bannerFileID ? (
              <p>
                <i>
                  *This home content already has Banner File uploaded. Uploading
                  again will replace the old one.
                </i>
              </p>
            ) : (
              <p>
                <i>*Please upload your banner image.</i>
              </p>
            )}
            <form onSubmit={handleSubmit}>
              <GridContainer>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: handleUpload,
                      type: "file",
                      inputProps: { accept: ".jpg,.jpeg" }
                    }}
                  />
                  {uploadError && (
                    <p style={{ color: "red" }}>
                      <i>{uploadError}</i>
                    </p>
                  )}
                </GridItem>
              </GridContainer>
              <Button onClick={() => props.history.goBack()} value="back">
                BACK
              </Button>
              <Button
                disabled={disabled || !uploadedFile}
                color="rose"
                type="submit"
                value="Submit"
              >
                Submit
              </Button>
            </form>
            <CustomInput
              labelText="Title"
              formControlProps={{
                fullWidth: true
              }}
              disabled
              inputProps={{
                value: bannerData.title === null ? "" : bannerData.title,
                disabled: true
              }}
            />
            <CustomInput
              labelText="Description"
              formControlProps={{
                fullWidth: true
              }}
              disabled
              inputProps={{
                value: bannerData.title === null ? "" : bannerData.description,
                disabled: true
              }}
            />
            <CustomInput
              labelText="Web Url"
              formControlProps={{
                fullWidth: true
              }}
              disabled
              inputProps={{
                value: bannerData.url === null ? "" : bannerData.url,
                disabled: true
              }}
            />
            <CustomInput
              labelText="Banner URL"
              formControlProps={{
                fullWidth: true
              }}
              disabled
              inputProps={{
                value: bannerData.banner === null ? "" : bannerData.banner,
                disabled: true
              }}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

UploadOnlineBookingHomeContent.propTypes = {
  history: PropTypes.object
};
